import styled from 'styled-components'

import { helpers } from 'styles'

export const Container = styled.div`
	padding: 8px 9px 8px 12px;
	border-radius: 12px;
	background-color: ${helpers.color.background};
	display: flex;
	justify-content: space-between;
	column-gap: 12px;
	align-items: center;
	font-family: monospace;
	font-size: ${helpers.font.size.smaller};
	border: 1px solid ${helpers.color.border};
`
